import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';


function HistorialCambios({ log, styles: s }) {
  const [abierto, setAbierto] = useState(false);
  return (
    <div style={s.card}>
      <div style={{...s.cardHeaderRow || s.cardTitle, display:'flex', alignItems:'center', justifyContent:'space-between', cursor:'pointer', marginBottom: abierto ? 16 : 0}} onClick={() => setAbierto(!abierto)}>
        <div style={s.cardTitle} >Historial de cambios {log.length > 0 && <span style={{fontSize:11, color:'#aaa', fontWeight:400}}>({log.length})</span>}</div>
        <span style={{fontSize:12, color:'#aaa'}}>{abierto ? '▲ Ocultar' : '▼ Mostrar'}</span>
      </div>
      {abierto && (
        log.length === 0 ? (
          <div style={s.emptySmall}>Sin cambios registrados</div>
        ) : (
          log.map((entry, i) => (
            <div key={i} style={{display:'flex',alignItems:'baseline',gap:12,padding:'10px 0',borderBottom:'0.5px solid #f0f0ed',fontSize:12}}>
              <span style={{color:'#aaa',flexShrink:0,fontFamily:'monospace',fontSize:11,minWidth:120}}>{new Date(entry.fecha).toLocaleString('es-ES',{day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'})}</span>
              <span style={{color:'#378ADD',flexShrink:0,fontWeight:500}}>{entry.usuario}</span>
              <span style={{color:'#666'}}>{entry.texto}</span>
            </div>
          ))
        )
      )}
    </div>
  );
}

export default function EmpleadoDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [empleado, setEmpleado] = useState(null);
  const [horas, setHoras] = useState([]);
  const [ausencias, setAusencias] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [log, setLog] = useState([]);
  const [modalAusencia, setModalAusencia] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);
  const [form, setForm] = useState({});
  const [formAusencia, setFormAusencia] = useState({ tipo: 'vacaciones', fecha_inicio: '', fecha_fin: '', motivo: '' });
  const [error, setError] = useState('');

  useEffect(() => { cargar(); }, [id]);

  const cargar = async () => {
    try {
      const [empRes, horasRes, ausRes, lRes] = await Promise.all([
        API.get(`/empleados/${id}`),
        API.get(`/empleados/${id}/horas`),
        API.get(`/ausencias?empleado_id=${id}`),
        API.get(`/log?entidad=empleado&entidad_id=${id}`),
      ]);
      setLog(lRes?.data || []);
      setEmpleado(empRes.data);
      setHoras(horasRes.data || []);
      setAusencias(ausRes.data || []);
    } catch(e) {}
    setCargando(false);
  };

  const guardarEditar = async () => {
    try {
      await API.put(`/empleados/${id}`, {
        nombre: form.nombre,
        email: form.email || null,
        cargo: form.cargo || null,
        coste_hora: form.coste_hora ? parseFloat(form.coste_hora) : null,
        es_externo: form.es_externo,
      });
      setModalEditar(false);
      cargar();
    } catch(e) { setError('Error al guardar'); }
  };

  const desactivar = async () => {
    if (!window.confirm(`¿Desactivar a ${empleado.nombre}?`)) return;
    await API.put(`/empleados/${id}`, { ...empleado, activo: false });
    cargar();
  };

  const activar = async () => {
    await API.put(`/empleados/${id}`, { ...empleado, activo: true });
    cargar();
  };

  const guardarAusencia = async () => {
    if (!formAusencia.fecha_inicio || !formAusencia.fecha_fin) { setError('Las fechas son obligatorias'); return; }
    try {
      await API.post('/ausencias', { ...formAusencia, empleado_id: parseInt(id) });
      setModalAusencia(false);
      setFormAusencia({ tipo: 'vacaciones', fecha_inicio: '', fecha_fin: '', motivo: '' });
      cargar();
    } catch(e) { setError('Error al guardar ausencia'); }
  };

  const eliminarAusencia = async (ausId) => {
    if (!window.confirm('¿Eliminar esta ausencia?')) return;
    try { await API.delete(`/ausencias/${ausId}`); cargar(); } catch(e) {}
  };

  const initials = (n) => n?.split(' ').map(x => x[0]).slice(0,2).join('').toUpperCase() || '?';

  const tipoAusenciaLabel = { vacaciones: 'Vacaciones', baja: 'Baja', permiso: 'Permiso', otro: 'Otro' };
  const tipoAusenciaColor = {
    vacaciones: { bg: '#E6F1FB', color: '#185FA5' },
    baja: { bg: '#FCEBEB', color: '#A32D2D' },
    permiso: { bg: '#F5EFD6', color: '#8B6914' },
    otro: { bg: '#f0f0ed', color: '#666' },
  };

  if (cargando) return <div style={styles.loading}>Cargando...</div>;
  if (!empleado) return <div style={styles.loading}>Empleado no encontrado</div>;

  return (
    <div style={styles.page}>
      <div style={styles.topbar}>
        <button style={styles.backBtn} onClick={() => navigate('/empleados')}>← Empleados</button>
      </div>

      <div style={styles.content}>

        {/* CABECERA */}
        <div style={styles.header}>
          <div style={styles.headerLeft}>
            <div style={{...styles.avatarLg, background: empleado.es_externo ? '#F5EFD6' : '#E6F1FB', color: empleado.es_externo ? '#8B6914' : '#185FA5'}}>
              {initials(empleado.nombre)}
            </div>
            <div>
              <div style={styles.nombre}>{empleado.nombre}</div>
              <div style={styles.cargo}>{empleado.cargo || 'Sin cargo asignado'}</div>
              <div style={styles.pills}>
                <span style={empleado.activo ? styles.pillActive : styles.pillInactive}>
                  {empleado.activo ? 'Activo' : 'Inactivo'}
                </span>
                <span style={empleado.es_externo ? styles.pillExterno : styles.pillInterno}>
                  {empleado.es_externo ? 'Externo' : 'Interno'}
                </span>
              </div>
            </div>
          </div>
          {usuario?.rol === 'admin' && (
            <div style={styles.headerActions}>
              <button style={styles.btnSecondary} onClick={() => { setForm({...empleado}); setError(''); setModalEditar(true); }}>Editar</button>
              {empleado.activo
                ? <button style={styles.btnDanger} onClick={desactivar}>Desactivar</button>
                : <button style={styles.btnSuccess} onClick={activar}>Activar</button>
              }
            </div>
          )}
        </div>

        {/* DATOS */}
        <div style={styles.grid2}>
          <div style={styles.card}>
            <div style={styles.cardTitle}>Información</div>
            <div style={styles.infoRow}><span style={styles.infoLabel}>Email</span><span>{empleado.email || '—'}</span></div>
            <div style={styles.infoRow}><span style={styles.infoLabel}>Cargo</span><span>{empleado.cargo || '—'}</span></div>
            <div style={styles.infoRow}><span style={styles.infoLabel}>Coste/hora</span><span>{empleado.coste_hora ? `${empleado.coste_hora}€` : '—'}</span></div>
            <div style={styles.infoRow}><span style={styles.infoLabel}>Tipo</span><span>{empleado.es_externo ? 'Colaborador externo' : 'Empleado interno'}</span></div>
            <div style={styles.infoRow}><span style={styles.infoLabel}>Alta</span><span>{empleado.fecha_alta ? new Date(empleado.fecha_alta).toLocaleDateString('es-ES') : '—'}</span></div>
          </div>

          <div style={styles.card}>
            <div style={styles.cardTitle}>Horas por proyecto</div>
            {horas.length === 0 ? (
              <div style={styles.emptySmall}>Sin horas imputadas</div>
            ) : (
              horas.map((h, i) => (
                <div key={i} style={styles.horaRow}>
                  <span style={styles.horaProyecto}>{h.proyecto_nombre || 'Proyecto'}</span>
                  <span style={styles.horaValor}>{h.total_horas}h</span>
                </div>
              ))
            )}
          </div>
        </div>

        {/* AUSENCIAS */}
        <div style={styles.card}>
          <div style={styles.cardHeaderRow}>
            <div style={styles.cardTitle}>Ausencias y bajas</div>
            {usuario?.rol === 'admin' && (
              <button style={styles.btnSmall} onClick={() => { setError(''); setModalAusencia(true); }}>+ Añadir</button>
            )}
          </div>
          {ausencias.length === 0 ? (
            <div style={styles.emptySmall}>Sin ausencias registradas</div>
          ) : (
            ausencias.map(a => (
              <div key={a.id} style={styles.ausenciaRow}>
                <span style={{...styles.pillTipo, background: tipoAusenciaColor[a.tipo]?.bg, color: tipoAusenciaColor[a.tipo]?.color}}>
                  {tipoAusenciaLabel[a.tipo] || a.tipo}
                </span>
                <span style={styles.ausenciaFechas}>
                  {new Date(a.fecha_inicio).toLocaleDateString('es-ES')} → {new Date(a.fecha_fin).toLocaleDateString('es-ES')}
                </span>
                <span style={styles.muted}>{a.motivo || ''}</span>
                {usuario?.rol === 'admin' && (
                  <button style={styles.btnEliminar} onClick={() => eliminarAusencia(a.id)}>✕</button>
                )}
              </div>
            ))
          )}
        </div>

      <HistorialCambios log={log} styles={styles} />
      </div>

      {/* MODAL EDITAR */}
      {modalEditar && (
        <div style={styles.overlay} onClick={() => setModalEditar(false)}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div style={styles.modalTitle}>Editar empleado</div>
              <button style={styles.closeBtn} onClick={() => setModalEditar(false)}>✕</button>
            </div>
            {error && <div style={styles.errorBox}>{error}</div>}
            <div style={styles.field}><label style={styles.label}>Nombre *</label><input style={styles.input} value={form.nombre || ''} onChange={e => setForm({...form, nombre: e.target.value})} /></div>
            <div style={styles.field}><label style={styles.label}>Email</label><input style={styles.input} value={form.email || ''} onChange={e => setForm({...form, email: e.target.value})} /></div>
            <div style={styles.field}><label style={styles.label}>Cargo</label><input style={styles.input} value={form.cargo || ''} onChange={e => setForm({...form, cargo: e.target.value})} /></div>
            <div style={styles.field}><label style={styles.label}>Coste hora (€)</label><input style={styles.input} type="number" value={form.coste_hora || ''} onChange={e => setForm({...form, coste_hora: e.target.value})} /></div>
            <div style={styles.field}>
              <label style={styles.label}>Tipo</label>
              <select style={styles.input} value={form.es_externo} onChange={e => setForm({...form, es_externo: e.target.value === 'true'})}>
                <option value="false">Interno</option>
                <option value="true">Externo / Colaborador</option>
              </select>
            </div>
            <div style={styles.modalFooter}>
              <button style={styles.btnSecondary} onClick={() => setModalEditar(false)}>Cancelar</button>
              <button style={styles.btn} onClick={guardarEditar}>Guardar cambios</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL AUSENCIA */}
      {modalAusencia && (
        <div style={styles.overlay} onClick={() => setModalAusencia(false)}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div style={styles.modalTitle}>Añadir ausencia</div>
              <button style={styles.closeBtn} onClick={() => setModalAusencia(false)}>✕</button>
            </div>
            {error && <div style={styles.errorBox}>{error}</div>}
            <div style={styles.field}>
              <label style={styles.label}>Tipo</label>
              <select style={styles.input} value={formAusencia.tipo} onChange={e => setFormAusencia({...formAusencia, tipo: e.target.value})}>
                <option value="vacaciones">Vacaciones</option>
                <option value="baja">Baja</option>
                <option value="permiso">Permiso</option>
                <option value="otro">Otro</option>
              </select>
            </div>
            <div style={styles.field}><label style={styles.label}>Fecha inicio</label><input style={styles.input} type="date" value={formAusencia.fecha_inicio} onChange={e => setFormAusencia({...formAusencia, fecha_inicio: e.target.value})} /></div>
            <div style={styles.field}><label style={styles.label}>Fecha fin</label><input style={styles.input} type="date" value={formAusencia.fecha_fin} onChange={e => setFormAusencia({...formAusencia, fecha_fin: e.target.value})} /></div>
            <div style={styles.field}><label style={styles.label}>Notas</label><input style={styles.input} value={formAusencia.motivo} onChange={e => setFormAusencia({...formAusencia, motivo: e.target.value})} placeholder="Opcional" /></div>
            <div style={styles.modalFooter}>
              <button style={styles.btnSecondary} onClick={() => setModalAusencia(false)}>Cancelar</button>
              <button style={styles.btn} onClick={guardarAusencia}>Guardar ausencia</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  page: { display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#f5f5f3', fontFamily: '-apple-system, BlinkMacSystemFont, Inter, sans-serif' },
  loading: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#aaa', fontSize: 14 },
  topbar: { background: 'white', borderBottom: '0.5px solid #e0e0d8', padding: '0 24px', height: 48, display: 'flex', alignItems: 'center' },
  backBtn: { background: 'none', border: 'none', fontSize: 13, color: '#378ADD', cursor: 'pointer', fontWeight: 500 },
  content: { padding: 24, display: 'flex', flexDirection: 'column', gap: 16 },
  header: { background: 'white', border: '0.5px solid #e0e0d8', borderRadius: 12, padding: 24, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 },
  headerLeft: { display: 'flex', alignItems: 'center', gap: 16 },
  avatarLg: { width: 52, height: 52, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, fontWeight: 600, flexShrink: 0 },
  nombre: { fontSize: 18, fontWeight: 600, color: '#1a1a1a', marginBottom: 2 },
  cargo: { fontSize: 13, color: '#888', marginBottom: 8 },
  pills: { display: 'flex', gap: 6 },
  headerActions: { display: 'flex', gap: 8 },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 },
  card: { background: 'white', border: '0.5px solid #e0e0d8', borderRadius: 12, padding: 20 },
  cardTitle: { fontSize: 13, fontWeight: 600, color: '#1a1a1a', marginBottom: 16 },
  cardHeaderRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 },
  infoRow: { display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '0.5px solid #f0f0ed', fontSize: 13, color: '#1a1a1a' },
  infoLabel: { color: '#888', fontSize: 13 },
  horaRow: { display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '0.5px solid #f0f0ed', fontSize: 13 },
  horaProyecto: { color: '#1a1a1a' },
  horaValor: { fontWeight: 600, color: '#378ADD' },
  ausenciaRow: { display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0', borderBottom: '0.5px solid #f0f0ed', fontSize: 13 },
  ausenciaFechas: { color: '#1a1a1a', flex: 1 },
  pillTipo: { fontSize: 11, padding: '2px 8px', borderRadius: 10, fontWeight: 500, flexShrink: 0 },
  muted: { color: '#aaa', fontSize: 12 },
  emptySmall: { fontSize: 13, color: '#aaa', padding: '16px 0', textAlign: 'center' },
  pillActive: { background: '#EAF3DE', color: '#3B6D11', fontSize: 11, padding: '2px 8px', borderRadius: 10, fontWeight: 500 },
  pillInactive: { background: '#f0f0ed', color: '#aaa', fontSize: 11, padding: '2px 8px', borderRadius: 10 },
  pillInterno: { background: '#E6F1FB', color: '#185FA5', fontSize: 11, padding: '2px 8px', borderRadius: 10, fontWeight: 500 },
  pillExterno: { background: '#F5EFD6', color: '#8B6914', fontSize: 11, padding: '2px 8px', borderRadius: 10, fontWeight: 500 },
  btn: { background: '#378ADD', color: 'white', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 500, cursor: 'pointer' },
  btnSmall: { background: '#378ADD', color: 'white', border: 'none', borderRadius: 6, padding: '5px 10px', fontSize: 12, cursor: 'pointer' },
  btnSecondary: { background: 'white', color: '#666', border: '0.5px solid #d0d0c8', borderRadius: 8, padding: '8px 14px', fontSize: 13, cursor: 'pointer' },
  btnDanger: { background: '#FCEBEB', color: '#A32D2D', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, cursor: 'pointer' },
  btnSuccess: { background: '#EAF3DE', color: '#3B6D11', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, cursor: 'pointer' },
  btnEliminar: { background: 'none', border: 'none', color: '#ccc', cursor: 'pointer', fontSize: 12, marginLeft: 'auto' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modal: { background: 'white', borderRadius: 12, border: '0.5px solid #e0e0d8', padding: 24, width: '100%', maxWidth: 440, maxHeight: '90vh', overflowY: 'auto' },
  modalHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 },
  modalTitle: { fontSize: 15, fontWeight: 500, color: '#1a1a1a' },
  closeBtn: { background: 'none', border: 'none', fontSize: 16, cursor: 'pointer', color: '#aaa' },
  errorBox: { background: '#FCEBEB', color: '#A32D2D', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 16 },
  field: { marginBottom: 16 },
  label: { display: 'block', fontSize: 13, color: '#444', marginBottom: 6, fontWeight: 500 },
  input: { width: '100%', padding: '9px 12px', borderRadius: 8, border: '0.5px solid #d0d0c8', fontSize: 14, outline: 'none', boxSizing: 'border-box', background: 'white' },
  modalFooter: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 24 },
};
